import React from 'react';
import * as Icon from 'react-feather';

const PawiOzellikler2 = () => {
    return (
        <>
            <div className="services-area ptb-80 bg-f7fafd">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-md-12 services-content">
                            <div className="section-title">
                                <h2>Pawi Net ile Kliniğinizi Kolayca Yönetin</h2>
                                <div className="bar"></div>
                                <p>
                                    Evcil hayvan kayıtlarından aşı ve stok takibine, randevu planlamadan sahip bilgilendirmelerine kadar klinik süreçlerinizi tek yerden yönetin.
                                </p>
                            </div>

                            <div className="row">
                                <div className="col-lg-6 col-md-6">
                                    <div className="box">
                                        <Icon.Heart /> Evcil hayvan kayıtları
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <div className="box">
                                        <Icon.User /> Hayvan sahibi bilgileri
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <div className="box">
                                        <Icon.Activity /> Planlanan aşıların takibi
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <div className="box">
                                        <Icon.Clock /> Geçmiş aşıların görüntülenmesi
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <div className="box">
                                        <Icon.Clipboard /> Muayene geçmişi
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <div className="box">
                                        <Icon.FileText /> Hastalık ve tedavi takibi
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <div className="box">
                                        <Icon.Calendar /> Randevu planlama
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <div className="box">
                                        <Icon.Edit /> İlaç uygulama kayıtları
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <div className="box">
                                        <Icon.Hash /> Barkodlu ilaç tanımlama
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <div className="box">
                                        <Icon.Package /> İlaç ve stok takibi
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <div className="box">
                                        <Icon.MessageCircle /> WhatsApp ve SMS bilgilendirmeleri
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="services-area ptb-80">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-md-12 services-content">
                            <div className="section-title">
                                <h2>Veteriner Kliniğinizin Dijital Asistanı</h2>
                                <div className="bar"></div>
                                <p>
                                    Pawi Net, kliniğinizin günlük işleyişini dijital ortama taşıyarak hasta kayıtlarına daha hızlı ulaşmanızı, aşı ve tedavi süreçlerini düzenli takip etmenizi sağlar. Böylece siz evcil dostlarımızın sağlığına odaklanırken Pawi Net klinik süreçlerinizi düzenlemenize yardımcı olur.
                                </p>
                            </div>

                            <div className="row">
                                <div className="col-lg-6 col-md-6">
                                    <div className="box">
                                        <Icon.Activity /> Aşı Takibi
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <div className="box">
                                        <Icon.Clipboard /> Muayene Geçmişi
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <div className="box">
                                        <Icon.AlertCircle /> Hastalık Takibi
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <div className="box">
                                        <Icon.FileText /> Tedavi Kayıtları
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <div className="box">
                                        <Icon.Package /> İlaç Stok Takibi
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <div className="box">
                                        <Icon.Hash /> Barkod Sistemi
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <div className="box">
                                        <Icon.MessageCircle /> WhatsApp ve SMS Bildirimi
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <div className="box">
                                        <Icon.Calendar /> Dijital Klinik Ajandası
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PawiOzellikler2;
